import React, {Component} from 'react'
import Registry from '../../../registry/index';
import { connect } from 'react-redux'

import RoundButton from '../UIKit/RoundButton/index'
import Anchor from '../UIKit/Anchor/index'
import JoinIcon from '../UIKit/Icon/Join'
import LeaveIcon from '../UIKit/Icon/Leave'

import {
    ROOM_STAYED,
    ROOM_TYPE_PERSONAL
} from '../../../constants/rooms';


class JoinLeaveButton extends Component {
	render() {
		let {roomInfo, roomStayed} = this.props;

        if (!roomInfo) return null;
        if (roomInfo.type == ROOM_TYPE_PERSONAL) return null;

		if (roomStayed) {
			return <LeaveButton style="anchor" roomInfo={roomInfo} {...this.props} />;
		} else {
			return <JoinButton style="anchor" roomInfo={roomInfo} {...this.props} />
		}
	}
}

class JoinButton extends Component {
	stayInRoom() {
        let {roomInfo} = this.props;

        this.props.dispatch({type: ROOM_STAYED, roomid: roomInfo.roomid});
    }

    renderRoundButton() {
        let lang = Registry.get('locale');
    	return <RoundButton label={lang.multi_rooms_join_full} border={false} shadow={true} background="white" size="small" icon={<JoinIcon size="small" colorIndex="primary"/>} onClick={this.stayInRoom.bind(this)} />
    }

    renderAnchor() {
        let lang = Registry.get('locale');
    	return <Anchor size="small" onClick={this.stayInRoom.bind(this)} label={lang.multi_rooms_join} />
    }

    render() {
		if (this.props.style == "round") {
			return this.renderRoundButton();
		} else {
			return this.renderAnchor();
		}
    }
}

class LeaveButton extends Component {
	leaveRoom() {
        let {roomActive, roomInfo} = this.props;

        if (!this.props.leaveEnabled) return false;
        if (!roomActive) {
            return false;
        }

        let chatInterface = Registry.get('chatInterface');

        chatInterface.leaveRoom(
            roomInfo.roomid,
            function() {},
            function() {})
    }

    renderRoundButton() {
        let color = "primary";
        if (!this.props.leaveEnabled) {
            color = "disabled";
        }
        let lang = Registry.get('locale');
    	return <RoundButton label={lang.multi_rooms_quit_full} border={false} shadow={true} background="white" size="small" icon={<LeaveIcon size="small" colorIndex={color}/>} onClick={this.leaveRoom.bind(this)} />
    }

    renderAnchor() {
        let disabled = !this.props.leaveEnabled;
        let lang = Registry.get('locale');
    	return <Anchor size="small" disabled={disabled} onClick={this.leaveRoom.bind(this)} label={lang.multi_rooms_quit} />
    }

    render() {
		if (this.props.style == "round") {
			return this.renderRoundButton();
		} else {
			return this.renderAnchor();
		}
    }
}

let ReduxJoinButton = connect()(JoinButton);
let ReduxLeaveButton = connect()(LeaveButton);

export {
	ReduxJoinButton as JoinButton,
	ReduxLeaveButton as LeaveButton
}

function mapStateToProps(state, ownProps) {
    let rooms = [];
    let enabled = true;
    let activeCount = 0;

    let chatInterface = Registry.get('chatInterface');
    let mainRoomId = chatInterface.getDefaultRoomId();

    for (let roomid in state.rooms) {
        if (state.rooms[roomid].active) {
            activeCount++;
        }
    }

    if ( (activeCount == 1) && (ownProps.roomInfo.roomid == mainRoomId)) {
        enabled = false;
    }

    return {
        leaveEnabled: enabled
    }
}

export default connect(mapStateToProps)(JoinLeaveButton);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/JoinLeaveButtons/index.js